<template>
  <div class="m-b-20">
    <b-field v-for="(filter, filterIndex) in filters" :key="filterIndex" :label="`${filter.name}: ${getFilterLabel(filter.options)}`">
      <form-select
        v-if="filter.options.length >= 42"
        :value="searchSelectedOption(filter.options)"
        :data="filter.options"
        field="name"
        select-value="id"
        @selected="selected"
      >
        <template slot-scope="props">
          <div class="columns is-mobile is-vcentered">
            <div v-if="props.row.filePivots[0]" class="column is-narrow" style="padding-right: 0;">
              <div style="width: 30px">
                <app-image
                  :key="props.row.filePivots[0].file.id"
                  ratio="1by1"
                  :src="getImageBySize(props.row.filePivots[0].file, 'small').src"
                  :webp-fallback="getImageBySize(props.row.filePivots[0].file, 'small').webpFallback"
                  :alt="props.row.name || 'option'"
                  lazy
                />
              </div>
            </div>
            <div class="column">
              <span :class="{'choice-select-unavailable': !!(!props.row.idYes && !props.row.selected)}">{{ props.row.name }}</span>
            </div>
          </div>
        </template>
      </form-select>
      <div v-else class="select-option-box columns is-vcentered is-mobile is-multiline is-variable is-3">
        <component
          :is="option.link && option.idNot ? 'a' : 'div'"
          v-for="(option, optionIndex) in filter.options"
          :key="optionIndex"
          :class="[{
            'column choice is-narrow': !option.filePivots[0],
            'choice-image': option.filePivots[0],
            'choice-unavailable': !!(!option.idYes && !option.selected),
            'choice-active': option.selected,
            'choice-loading': loadingFilter && loadingFilter.optionId === option.id
          }, 'is-relative']"
          v-bind="option.link && option.idNot ? { href: localePath({ name: 'product', params: { productName: option.link, productId: option.idNot} }) } : {}"
          @click.prevent="selected(option)"
        >
          <b-loading :is-full-page="false" :active="loadingFilter && loadingFilter.optionId === option.id" :can-cancel="false" class="choice-b-loading" />
          <template v-if="option.filePivots[0]">
            <b-tooltip :label="option.name">
              <div class="choice-image-container">
                <app-image
                  :key="option.filePivots[0].file.id"
                  ratio="1by1"
                  :src="getImageBySize(option.filePivots[0].file, 'small').src"
                  :webp-fallback="getImageBySize(option.filePivots[0].file, 'small').webpFallback"
                  :alt="option.name || 'option'"
                  lazy
                />
                <div v-if="option.tags && option.tags.length > 0" class="option-tag-overlay">
                  <option-tag-badge
                    :color="option.tags[0].color"
                    :has-icon="option.tags[0].hasIcon"
                    :label="getTagName(option.tags[0])"
                    size="small"
                  />
                </div>
              </div>
            </b-tooltip>
          </template>
          <template v-else>
            <div class="no-image-content">
              <span class="no-image-name">{{ option.name }}</span>
              <option-tag-badge
                v-if="option.tags && option.tags.length > 0"
                :color="option.tags[0].color"
                :has-icon="option.tags[0].hasIcon"
                :label="getTagName(option.tags[0])"
                size="small"
              />
            </div>
          </template>
        </component>
      </div>
    </b-field>
  </div>
</template>

<script>
import FormSelect from 'marketplace-front-core/components/form/select'
import tagsConfig from 'marketplace-front-core/config/tags'
import OptionTagBadge from 'marketplace-front-core/components/tags/OptionTagBadge'

export default {
  components: { FormSelect, OptionTagBadge },
  props: {
    filters: {
      type: Array,
      default: null
    },
    loadingFilter: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      availableTagColors: tagsConfig.colors || []
    }
  },
  methods: {
    getFilterLabel (data) {
      const findOption = data.find(x => x.selected === true)
      if (findOption) {
        return findOption.name
      } else {
        return ''
      }
    },
    selected (option) {
      if (!option.selected && (option.idYes || option.idNot)) {
        const productId = option.idYes || option.idNot
        this.$emit('selected', productId, option.id)
      }
    },
    searchSelectedOption (data) {
      const find = data.find(x => x.selected === true)
      if (find) { return find.id }
    },

    getTagName (tag) {
      return tag.name && tag.name.trim() ? tag.name.trim() : ''
    },

    getTagClass (colorName) {
      if (!colorName) { return '' }
      const colorConfig = this.availableTagColors.find(c => c.value === colorName)
      if (colorConfig) {
        return `option-tag-${colorConfig.value}`
      }
      return `option-tag-${colorName.toLowerCase()}`
    }
  }
}
</script>

<style lang="scss" scoped>
.choice-image-container {
  position: relative;
}

.no-image-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
}

.option-tag-overlay {
  position: absolute !important;
  bottom: 0px;
  width: 100%;
  right: 0px;
  left: 0px;
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}
</style>
